import { render, staticRenderFns } from "./CardListUser.vue?vue&type=template&id=c37eded4&"
import script from "./CardListUser.vue?vue&type=script&lang=js&"
export * from "./CardListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports